/**
 * feat_340 — Primer nombre de un User.
 *
 * `Users.name` es un campo único (no hay `lastName`): conviven "Sofia Paez" y
 * "Marina". Para el chip de asesor del zócalo alcanza con el primer token.
 * Sin nombre → "" (el caller decide el fallback).
 */

export const userFirstName = (name) => {
  const n = (name || "").trim();
  if (!n) return "";
  return n.split(/\s+/)[0];
};

export default userFirstName;
